"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidExpression = isValidExpression;
const FormulaParser_1 = require("../parser/FormulaParser");
const FormulaTokenizer_1 = require("../tokenizer/FormulaTokenizer");
/**
 * Validates whether a given expression is a valid formula that can be parsed and evaluated.
 *
 * This function performs syntax checking without executing the expression, making it useful
 * for input validation before evaluation.
 *
 * @param {string} expression - The expression string to validate
 * @returns {boolean} true if the expression is syntactically valid, false otherwise
 *
 * @example
 * ```typescript
 * isValidExpression("2 + 3 * 4"); // true
 * isValidExpression("x > 10 ? 'high' : 'low'"); // true
 * isValidExpression("2 +"); // false - incomplete expression
 * isValidExpression("(a + b * c"); // false - unmatched parentheses
 * ```
 *
 * @note This function only checks syntax validity, not semantic correctness (e.g., undefined variables)
 */
function isValidExpression(expression) {
    try {
        const fTokenizer = new FormulaTokenizer_1.FormulaTokenizer();
        const fParser = new FormulaParser_1.FormulaParser();
        const tokens = fTokenizer.execute(expression);
        return fParser.isValidFormula(tokens);
    }
    catch (_a) {
        return false;
    }
}
